
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { STAFF_AUGMENTATION } from '../../../Constants/strings';
import ProfilePicPlaceHolder from '../../../Assets/images/png/profil-pic-placeholder-large.png';
import CommonTextField from '../../../Components/TextField/textField';
import PropTypes from 'prop-types';

const addEditStaffAugFields = ({
  data,
  errors,
  salesMemberOptions,
  deliveryManagerOptions,
  loadingSalesMembers,
  loadingDeliveryManagers,
  handleSalesMemberChange,
  handleDeliveryManagerChange,
  styles,
  handleAutoFieldChange,
}) => {


  return (
    <>
      <div className="multiple-field-container">
        <div className='employee-field'>
          <label
            htmlFor="select-sales-member-name"
            className="employee-name-label"
          >
            {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.SALES_MEMBER}
            <span className="mandatory-star"> *</span>
          </label>
          <Autocomplete
            inputValue={data.salesMember?.fullName}
            value={data?.salesMember || null}
            classes={{ noOptions: styles.noOptions }}
            id="sales-member"
            onChange={(_event_, newValue) => handleAutoFieldChange('salesMember', newValue)}
            onInputChange={(_event_, newValue) => {
              handleSalesMemberChange(newValue);
            }}
            loadingText={
              <div>
                <CircularProgress size={24} />
              </div>
            }
            loading={loadingSalesMembers}
            isOptionEqualToValue={(option, value) =>
              option.fullName === value.fullName
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={
                  STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER
                    .ENTER_SALE_MEMBER
                }
                className="custom-input"
                margin="normal"
                variant="outlined"
                fullWidth
                required
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <img
                  src={option.photoSignedUrl || ProfilePicPlaceHolder}
                  alt="Profile"
                  className="profile-image"
                />
                {`${option.fullName} . ${option.employeeId}`}
              </li>
            )}
            getOptionLabel={(option) => option.fullName || ''}
            options={salesMemberOptions}
          />
          {errors?.salesMember && (
            <div className="staff-aug-error">
              <small>{errors?.salesMember}</small>
            </div>
          )}
        </div>
        <div className='employee-field'>
          <label htmlFor="map-employee-name" className="employee-name-label">
            {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.DELIVERY_MANAGER}
            <span className="mandatory-star"> *</span>
          </label>
          <Autocomplete
            classes={{ noOptions: styles.noOptions }}
            id="delivery-manager"
            inputValue={data.deliveryManager?.fullName}
            value={data?.deliveryManager || null}
            onChange={(_event_, newValue) => handleAutoFieldChange('deliveryManager', newValue)}
            onInputChange={(_event_, newValue) => {
              handleDeliveryManagerChange(newValue);
            }}
            loadingText={
              <div>
                <CircularProgress size={24} />
              </div>
            }
            loading={loadingDeliveryManagers}
            getOptionLabel={(option) => option.fullName || ''}
            isOptionEqualToValue={(option, value) =>
              option.fullName === value.fullName
            }
            options={deliveryManagerOptions}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={
                  STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER
                    .ENTER_DELIVERY_MANAGER
                }
                margin="normal"
                className="custom-input"
                variant="outlined"
                fullWidth
                required
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <img
                  src={option.photoSignedUrl || ProfilePicPlaceHolder}
                  alt="Profile"
                  className="profile-image"
                />
                {`${option.fullName} . ${option.employeeId}`}
              </li>
            )}
          />
          {errors?.deliveryManager && (
            <div className="staff-aug-error">
              <small>{errors?.deliveryManager}</small>
            </div>
          )}
        </div>
      </div>
      <div className="multiple-field-container id-textField">
        <div className='employee-field'>
          <CommonTextField
            label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.SALES_MEMBER_ID}
            value={data?.salesMember?.employeeId || ''}
            variant="outlined"
            size="small"
            id="sales-member-id"
            disabled
          />
        </div>
        <div className='employee-field'>
          <CommonTextField
            label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.DELIVERY_MANAGER_ID}
            value={data?.deliveryManager?.employeeId || ''}
            variant="outlined"
            autoFocus={false}
            size="small"
            id="delivery-manager-id"
            disabled
          />
        </div>
      </div>
    </>
  );
};

addEditStaffAugFields.propTypes = {
  data: PropTypes.object.isRequired,
  setFieldData: PropTypes.func,
  errors: PropTypes.object.isRequired,
  salesMemberOptions: PropTypes.array.isRequired,
  deliveryManagerOptions: PropTypes.array.isRequired,
  loadingSalesMembers: PropTypes.bool.isRequired,
  loadingDeliveryManagers: PropTypes.bool.isRequired,
  handleSalesMemberChange: PropTypes.func.isRequired,
  handleDeliveryManagerChange: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  verticalList: PropTypes.array,
  handleFieldChange: PropTypes.func,
  handleAutoFieldChange: PropTypes.func.isRequired,
};

export default addEditStaffAugFields;
